/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import { IModules, IModuleTile, IUserSettings } from '../interfaces/interfaces';

const UserTileContext = React.createContext({
  tiles: [{}] as IModuleTile[],
  addTile: (tile: IModuleTile) => {
    /**/
  },
  removeTile: (tileId: string) => {
    /**/
  },
  setTiles: (tiles: IModuleTile[]) => {
    /**/
  },
  modules: {},
  settings: {} as IUserSettings,
  setSettings: (settings: IUserSettings) => {
    /**/
  },
  refTiles: [{}],
  setRefTiles: (refTiles: IModuleTile[]) => {
    /**/
  },
});

export function useTiles(): [
  tiles: IModuleTile[],
  addTile: (tile: IModuleTile) => void,
  removeTile: (tileId: string) => void,
  setTiles: (tiles: IModuleTile[]) => void,
  modules: IModules,
  setModules: (modules: IModules) => void,
  isLoaded: boolean,
  setIsLoaded: (v: boolean) => void,
  settings: IUserSettings,
  setSettings: (v: IUserSettings) => void,
  refTiles: IModuleTile[],
  setRefTiles: (refTiles: IModuleTile[]) => void,
] {
  const [tiles, setTiles] = useState<IModuleTile[]>([]);
  const [refTiles, setRefTiles] = useState<IModuleTile[]>([]);
  const [modules, setModules] = useState<IModules>({});
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [settings, setSettings] = useState<IUserSettings>({ didFinishOnboarding: false });

  const addTile = (tile: IModuleTile) => {
    setTiles([...tiles, tile]);
  };

  const removeTile = (tileId: string) => {
    setTiles(tiles.filter((t) => t.id !== tileId));
  };

  return [
    tiles,
    addTile,
    removeTile,
    setTiles,
    modules,
    setModules,
    isLoaded,
    setIsLoaded,
    settings,
    setSettings,
    refTiles,
    setRefTiles,
  ];
}

export const UserTileContextProvider = UserTileContext.Provider;
export const UserTileContextConsumer = UserTileContext.Consumer;
export default UserTileContext;
